import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SparklesIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  const bonuses = [{
    number: 1,
    title: 'Lista de Proveedores Por País',
    description: '¡No te preocupes por dónde comprar los materiales! Recibirás nuestra lista exclusiva de proveedores en cada país de Latinoamérica. Los mejores lugares para que adquieras los materiales al menor precio posible.',
    value: '18'
  }, {
    number: 2,
    title: 'Libro de Saponificación en Frío',
    description: 'Aprenderás esta técnica ancestral que te permitirá crear jabones únicos, personalizados y de calidad excepcional. La saponificación en frío es el método preferido por las jaboneras profesionales de todo el mundo.',
    value: '18'
  }, {
    number: 3,
    title: 'Libro Moldes Caseros de Silicona',
    description: 'Con este libro aprenderás paso a paso a elaborar una gran variedad de moldes en casa que te permitirá ahorrar MUCHO dinero. En vez de comprar moldes costosos, los fabricarás tú misma. ¡Un ahorro brutal!',
    value: '18'
  }, {
    number: 4,
    title: 'Libro Introducción a la Aromaterapia',
    description: 'Aprenderás los diferentes tipos, propiedades y modos de uso de los aceites esenciales. Este conocimiento es CLAVE para crear jabones con aromas irresistibles que tus clientes amarán.',
    value: '18'
  }, {
    number: 5,
    title: 'Libro Cremas Faciales y Corporales en Casa',
    description: 'Aprenderás paso a paso a elaborar cremas para estrías, cremas antiarrugas, cremas para manos, cremas para hombres y muchas más. ¡Amplía tu catálogo de productos! No solo venderás jabones; venderás una línea COMPLETA.',
    value: '18'
  }, {
    number: 6,
    title: 'Libro Cuidado Natural de la Piel',
    description: 'Encontrarás consejos prácticos para cuidar tu piel de manera natural y lograr una apariencia radiante. Este conocimiento te posiciona como una EXPERTA ante tus clientes.',
    value: '18'
  }, {
    number: 7,
    title: 'Libro Estrategias de Venta Para Tu Negocio',
    description: 'Si tu objetivo es EMPRENDER, este libro es tu biblia. Aprenderás las mejores estrategias de venta para iniciar e impulsar tu negocio al siguiente nivel. Herramientas efectivas y probadas para lograr el éxito.',
    value: '27'
  }, {
    number: 8,
    title: 'Libro Velas Artesanales Como Negocio',
    description: 'Y para rematar, ¡aprenderás OTRO negocio rentable! Con este libro digital aprenderás paso a paso a elaborar hermosas velas en casa: Velas de Soja, Velas de Gel, Velas Aromáticas y muchas más. ¡DOS negocios por el precio de uno!',
    value: '18'
  }, {
    number: 9,
    title: 'Membresía VIP de Por Vida',
    description: 'Te conviertes en miembro de nuestra comunidad exclusiva y recibirás actualizaciones y bonos mes a mes sin ningún costo adicional. Nuevas recetas, nuevas técnicas, nuevos recursos... ¡para siempre!',
    value: '18'
  }];
  const totalBonusValue = bonuses.reduce((sum, bonus) => sum + parseInt(bonus.value), 0);
  return <section className="w-full py-16 md:py-24 px-4 bg-gradient-to-br from-gold/20 to-terracotta/20" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-12">
          <div className="inline-flex items-center gap-3 bg-gold text-white px-6 py-3 rounded-full mb-6" data-id="element-13">
            <GiftIcon className="w-6 h-6" data-id="element-14" />
            <span className="font-montserrat font-bold text-lg" data-id="element-15">
              BONOS EXCLUSIVOS
            </span>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-brown mb-4" data-id="element-16">
            Reclama Estos 9 Bonos EXCLUSIVOS Si Accedes HOY
          </h2>
          <p className="font-inter text-xl text-brown/80" data-id="element-17">
            Si entras hoy, te daré 9 bonos especiales por tiempo limitado que te
            ayudarán a empezar con tus jabones artesanales aún más rápido...
          </p>
        </motion.div>

        {/* Bonuses List */}
        <div className="space-y-6 mb-12" data-id="element-18">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-lg border-4 border-gold/30 overflow-hidden" data-id="element-19">
              <div className="flex flex-col md:flex-row" data-id="element-20">
                {/* Bonus Image/Icon */}
                <div className="w-full md:w-48 bg-gradient-to-br from-gold to-terracotta flex items-center justify-center p-8" data-id="element-21">
                  <div className="text-center text-white" data-id="element-22">
                    <SparklesIcon className="w-16 h-16 mx-auto mb-2" data-id="element-23" />
                    <p className="font-montserrat font-bold text-2xl" data-id="element-24">
                      BONO #{bonus.number}
                    </p>
                  </div>
                </div>

                {/* Bonus Content */}
                <div className="flex-1 p-6 md:p-8" data-id="element-25">
                  <h3 className="font-playfair text-2xl font-bold text-brown mb-3" data-id="element-26">
                    {bonus.title}
                  </h3>
                  <p className="font-inter text-base text-brown/80 mb-4 leading-relaxed" data-id="element-27">
                    {bonus.description}
                  </p>
                  <div className="flex items-center gap-3" data-id="element-28">
                    <span className="font-inter text-sm text-brown/60 line-through" data-id="element-29">
                      Precio Regular: <PriceDisplay amount={bonus.value} data-id="element-30" /> USD
                    </span>
                    <span className="font-montserrat font-bold text-lg text-sage" data-id="element-31">
                      — ¡Tuyo GRATIS!
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-r from-terracotta to-sage p-1 rounded-2xl" data-id="element-32">
          <div className="bg-white p-8 md:p-12 rounded-xl text-center" data-id="element-33">
            <p className="font-inter text-lg text-brown/80 mb-4" data-id="element-34">
              Valor Total de Todos los Bonos:
            </p>
            <p className="font-playfair text-5xl md:text-6xl font-bold text-brown mb-4" data-id="element-35">
              <PriceDisplay amount={totalBonusValue.toString()} className="line-through text-brown/40" data-id="element-36" />{' '}
              USD
            </p>
            <div className="inline-block bg-sage text-white px-8 py-4 rounded-full" data-id="element-37">
              <p className="font-montserrat font-bold text-3xl" data-id="element-38">
                ¡TODO GRATIS HOY!
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}